import { render, staticRenderFns } from "./RegistrationPage.vue?vue&type=template&id=25752896&scoped=true"
import script from "./RegistrationPage.vue?vue&type=script&lang=js"
export * from "./RegistrationPage.vue?vue&type=script&lang=js"
import style0 from "./RegistrationPage.vue?vue&type=style&index=0&id=25752896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25752896",
  null
  
)

export default component.exports